import AccountCardAlbumCustomPrintOption from './AccountCardAlbumCustomPrintOption';

export default AccountCardAlbumCustomPrintOption;
